/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide password`)
};

const zh_hans1_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏密码`)
};

const zh_hant1_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱藏密碼`)
};

const fr_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer le mot de passe`)
};

const de_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort ausblenden`)
};

const ja_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを隠す`)
};

const ko_login_hide_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 숨기기`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_hide_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_hide_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_hide_password", locale)
	if (locale === "en") return en_login_hide_password(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_hide_password(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_hide_password(inputs)
	if (locale === "fr") return fr_login_hide_password(inputs)
	if (locale === "de") return de_login_hide_password(inputs)
	if (locale === "ja") return ja_login_hide_password(inputs)
	return ko_login_hide_password(inputs)
};